/*
 * UserSkillUpdateButton Messages
 *
 * This contains all the text for the UserSkillUpdateButton component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  success: {
    id: 'graphql.user.update.skill.success',
    defaultMessage: 'Skill {skillName} updated successfully!',
  },
});
